import { type fabric } from 'fabric';
import { type CopiedWhiteboardContent } from '../collaboration/Serialization';
import type WhiteboardController from '../controllers/WhiteboardController';
import { type MouseEventData } from '../external-types';
import ToolPaste from '../tools/ToolPaste';
import type Stylus from './Stylus';
import DraggableBrush from './DraggableBrush';

export class ClipboardDataDrawingBrush extends DraggableBrush {
  constructor(
    private readonly clipboardData: CopiedWhiteboardContent,
    private readonly controller: WhiteboardController,
    private readonly stylus: Stylus
  ) {
    super();
  }

  async startDragging(point: fabric.IPoint) {
    await ToolPaste.pasteContents(this.controller, this.clipboardData, point);
    this.controller.canvas.setActiveObject(this.controller.selection);
    return this.controller.selection;
  }

  // Empty implementation needed otherwise an error is thrown
  onMouseDown(): void {}

  // Empty implementation needed otherwise an error is thrown
  onMouseMove(): void {}

  onMouseUp(eventData: MouseEventData) {
    if (!eventData.pointer) {
      console.error(
        'eventData.pointer should exist on onMouseUp event argument'
      );
      return;
    }
    void ToolPaste.pasteContents(
      this.controller,
      this.clipboardData,
      eventData.pointer
    );
    this.stylus.drawingComplete();
  }
}
